// extracted by mini-css-extract-plugin
export var avatarContainer = "_7w-0";
export var avatarTypingWave = "_7w-i";
export var gray = "_7w-f";
export var green = "_7w-c";
export var icon = "_7w-9";
export var image = "_7w-1";
export var lg = "_7w-6";
export var md = "_7w-5";
export var presenceDot = "_7w-b";
export var red = "_7w-d";
export var sm = "_7w-4";
export var status = "_7w-a";
export var typingDot = "_7w-h";
export var typingPill = "_7w-g";
export var xl = "_7w-7";
export var xs = "_7w-3";
export var xxl = "_7w-8";
export var xxs = "_7w-2";
export var yellow = "_7w-e";